<template>
  <div class="detail-page">
    <div class="title">
      <span>{{dataList.title}}</span>
    </div>
    <div v-html="dataList.content" class="container_box">
      
    </div>
    <div class="comment" v-if="comments.length">
      <span class="flex">
        <img src="../../assets/img/zao.png" alt="">
        顶（<span class="colorNum">0</span>）
      </span>

       <span class="flex">
        <img src="../../assets/img/cai.png" alt="">
        踩（<span class="colorNum">0</span>）
      </span>
       <span class="flex">
        <img src="../../assets/img/share.png" alt="">
        分享（<span class="colorNum">0</span>）
      </span>
       <span class="flex">
        <img src="../../assets/img/see.png" alt="">
        浏览次数（<span class="colorNum">0</span>）
      </span>
       <span class="flex">
        <img src="../../assets/img/collect.png" alt="">
        收藏（<span class="colorNum">0</span>）
      </span>

    </div>
    <div class="togo">
      <span> 上一条：终于盼到了！</span>
		  <span> 下一条：为何整合营销需要的</span>     
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import Qs from 'qs'
export default {
  props:{
    dataList:{
      type:Object,
      default:()=>{{}}
    },
    comments:{
      type:Array,
      default:()=>{{}}
    }
  },
  data(){
    return {
    }
  },
  created(){
  },
  methods:{
  }
}
</script>
<style scoped lang="scss">
.detail-page {
  width: 850px;
  padding-left: 16px;
  padding-right: 10px;
  .title {
    margin-bottom: 35px;
    text-align: center;
    span {
      font-size: 24px;
      color: #333;
    }
  }
  .container_box {
    font-size: 16px;
    color: #191919;
    text-indent: 4em;
  }
  .togo {
    display: flex;
    justify-content: space-around;
    margin: 40px 0;
    display: none;
    cursor: pointer;
    span {
      font-size: 14px;
    }
  }
}
.flex{
  display: flex;
  align-items: center;
}

.comment{
  display: flex;
  padding: 0 20px;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  .colorNum{
    color: #cf4b01;
  }
}
</style>